// import { Api } from '@/service';
import codes from '@/codes';

//restful api
import { agent as wsfinder } from '@/service/api/wsfinder'

export default {
  data : () => {
    return {
      codes,
      confirm: false,
      add: false,
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_agent'}); },
    async remove() {
      try {
        // let rs = await Api.Manager('agent', 'delete', { id : this.model.id })
        let rs = await wsfinder.deleteAgent({ id : this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
        this.list(); this.$emit("refresh");
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('agent.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }
      try{
        console.log(id)
        // let rs = await Api.Manager_Call('wsfinder.agent', 'detail', { id : id })
        let rs = await wsfinder.detailAgent({ id : id })
        console.log(rs)

        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('agent.detail.vue', 'created'); },
  destroyed: function() { console.log('agent.detail.vue', 'destroyed'); },
  mounted: function() { console.log('agent.detail.vue', 'mounted'); this.get(this.$route.params); },
}